export default __webpack_public_path__ + "static/media/nao-vai-ter-golpe.8cd0b8c3.jpg";